'use client';
import { useEffect, useMemo } from 'react';
import { BaseContentResponse } from 'lib/services/models/content-response';
import { DataLayerEvent, pushToDataLayer } from 'components/helpers/Global/Analytics/DataLayer';

export const buildContentResultPayload = ({
  content,
  isNumberedList,
  language,
  contentType,
  recordType,
}: {
  content: Partial<BaseContentResponse>;
  isNumberedList: boolean;
  language: string | undefined | null;
  contentType: string;
  recordType?: string;
}): DataLayerEvent => {
  const contentListName = isNumberedList ? 'SideBySide-NumberedList' : 'SideBySide-UnorderedList';
  const templateName = 'PandoSites/NumberedList';

  const contentTypeValue = contentType;
  const recordTypeValue = recordType;

  const payload: DataLayerEvent = {
    event: 'content_result',
    content_id: content?.ContentId || '',
    content_title: content?.Title || '',
    content_type: contentTypeValue,
    record_type: recordTypeValue,
    content_list_name: contentListName,
    language: (language || 'en').toLowerCase(),
    template_name: templateName,
  };

  return payload;
};

export function useContentResultAnalytics(
  content: Partial<BaseContentResponse>,
  isNumberedList: boolean,
  language?: string | null,
  contentType?: string,
  recordType?: string
): void {
  const payload = useMemo(
    () =>
      buildContentResultPayload({
        content,
        isNumberedList,
        language,
        contentType: contentType || 'Content',
        recordType: recordType || 'Content',
      }),
    [content, isNumberedList, language, contentType, recordType]
  );

  useEffect(() => {
    pushToDataLayer(payload);
  }, [payload]);
}
